// extracted by mini-css-extract-plugin
export default {"editButton":"EditButton_editButton__vy1HX","arrowLeftIcon":"EditButton_arrowLeftIcon__pNoYl"};